import React, {useState, useRef, useEffect} from 'react'

import {AiFillCamera} from 'react-icons/ai'
import {useAppend, useUploadPhoto} from '../hooks/mutations'
import { updateDevices } from '../lib/utils';
import {useStateContext} from '../context/StateContext';
import {Loading, VisDiv} from '../components';
import { successAlert, errorAlert, keyId, convertBase64 } from '../lib/utils';
import { geoPosition } from '../hooks/geo';
import { v4 as uuidv4, v4 } from 'uuid';
import { optimizeImage } from '../hooks/imageOptimizer';

const InsertPhoto = ({saveFn}) => {
    const [loading, setLoading] = useState(false);
    const [imageAsset, setImageAsset] = useState();
    const [wrongImageType, setWrongImageType] = useState(false); 
    const hiddenFileInput = React.useRef(undefined);
    const testing = false
    const {devices, setDevices, currentDevice, setCurrentDevice, setDeviceNonConformities, deviceNonConformities, sUser} = useStateContext();


const onTestClick = () =>{
   //setLoading(true)
  console.log("currentDevice", currentDevice)
}

    const handleClick = event => {
      hiddenFileInput.current.click();
    };

    const saveImage = (file, base64, position="") => {
      const doc = {
        _type: 'object',
        _key: keyId(),
        src: base64, 
        fileType: file?.type,
        fileName: file?.name,
        longitude:position?.coords?.longitude,
        latitude:position?.coords?.latitude,
        postedOn: Date.now(), 
        postedBy: { _type: 'postedBy', _ref: sUser._id }, 
        status:"ATTIVO",

      }
      //console.log("DOC IMAGE", doc)
      saveFn(doc)
      setLoading(false) // Clear loading state after successful save
      //addPhoto({documentId:destination._id, arrayName:'image',doc: doc})
    }

    const deletePhoto = () => {
        //console.log("delete photo")
    }

    const uploadImage = async (e) => {
      try {
        setLoading(true);
        const file = e.target.files[0];
        console.log("ahfniluqfh offline file", file)
        // Validate file type first
        const validTypes = ['image/png', 'image/heic', 'image/svg', 'image/jpeg', 'image/gif', 'image/webp', 'image/tiff'];
        if (!validTypes.includes(file.type)) {
          setLoading(false);
          setWrongImageType(true);
          errorAlert("il formato della foto non è valido");
          return;
        }

        // Optimize image before converting to base64
        const optimizedFile = await optimizeImage(file);
        console.log("òqoi4jrfòo optimised file", optimizedFile)
        const base64 = await convertBase64(optimizedFile);
        console.log("qòofhehb offline base64", base64)
        setWrongImageType(false);
        setImageAsset(base64);
        saveImage(optimizedFile, base64);
        // Try to get position with a shorter timeout
/*         try {
          const position = await new Promise((resolve, reject) => {
            navigator.geolocation.getCurrentPosition(
              resolve,
              reject,
              { enableHighAccuracy: true, timeout: 5000 }
            );
          });
          saveImage(optimizedFile, base64, position);
        } catch (geoError) {
          // If geolocation fails, continue without position
          console.log("Geolocation not available (this is normal when offline)");
          // Still save the image, just without location data
          saveImage(optimizedFile, base64, {
            coords: {
              latitude: null,
              longitude: null
            }
          });
        } */
      } catch (error) {
        console.error("Upload error:", error);
        setLoading(false);
        errorAlert("Errore durante il caricamento dell'immagine");
      }
      
      //const position = geoPosition()

    };
    

 /*    if (loading) 
    return <Loading/>; */
  return (
    <div>
      <VisDiv rules={[testing]}>
        <button onClick={onTestClick}>test</button>  
      </VisDiv>     

      <button onClick={handleClick} className='round-button-no-hover'>
        <AiFillCamera
        size={25}
        color={"white"}
        />
      </button>
      <input
        type="file"
        name="upload-image"
        ref={hiddenFileInput}
        style={{display:"none"}}
        onChange={(e)=>uploadImage(e)}
        className="insert-photo-button"
      />
    </div>
  )
}

export default InsertPhoto
